import { EnumEntityStructureTypeMD } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumEntityStructureType';
import { EnumTreeEntityLevelMD } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumTreeEntityLevel';
import { EnumDataTypeMD } from '../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { EnumElementStatusMD } from '../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumElementStatus';
import { EnumAccessModifierMD } from '../../../../../api/com/MetaPattern/MDA/MD/Base/EnumAccessModifier';
import { EnumComponentTypeMD } from '../../../../../api/com/MetaPattern/MDA/MD/Base/EnumComponentType';
import { EnumInheritanceModifierMD } from '../../../../../api/com/MetaPattern/MDA/MD/Base/EnumInheritanceModifier';
import { EnumDTPTypeMD } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumDTPType';
import { EnumHTTPMethodMD } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumHTTPMethod';
import { EnumHTTPParameterSourceMD } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumHTTPParameterSource';
import { EnumMultiplicityMD } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumMultiplicity';
import { EnumNetworkProtocolMD } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumNetworkProtocol';
import { EnumPersistenceTypeMD } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumPersistenceType';
import { EnumRelationshipTypeMD } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumRelationshipType';
import { EnumServiceActionTypeMD } from '../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumServiceActionType';
import { EnumAlignStyleMD } from '../../../../../api/com/MetaPattern/MDA/MD/UIModel/EnumAlignStyle';
import { EnumPageTypeMD } from '../../../../../api/com/MetaPattern/MDA/MD/UIModel/EnumPageType';
import { EnumRefStyleMD } from '../../../../../api/com/MetaPattern/MDA/MD/UIModel/EnumRefStyle';
import { EnumSearchStyleMD } from '../../../../../api/com/MetaPattern/MDA/MD/UIModel/EnumSearchStyle';
import { EnumSortStyleMD } from '../../../../../api/com/MetaPattern/MDA/MD/UIModel/EnumSortStyle';
import { EnumItemMD } from './EnumItemMD';
import { EnumRoleTypeMD } from '@/api/com/MetaPattern/MDA/MD/APPModel/EnumRoleType';
import { EnumAPPRelationshipTypeMD } from '@/api/com/MetaPattern/MDA/MD/APPModel/EnumAPPRelationshipType';

/* 元数据工厂需要完整的元数据支持才能使用，需要重新做 */
export class EnumMDFactory {
  static getEnumMD(enumName: string): Array<EnumItemMD> {
    let items: Array<EnumItemMD> = null;
    let trueName = enumName;
    if (enumName.indexOf('.') >= 0) {
      const nameItems = enumName.split('.');
      trueName = nameItems[nameItems.length - 1];
    }
    switch (trueName) {
      case 'EnumComponentType':
        items = EnumComponentTypeMD.getItems();
        break;
      case 'EnumDataType':
        items = EnumDataTypeMD.getItems();
        break;
      case 'EnumElementStatus':
        items = EnumElementStatusMD.getItems();
        break;
      case 'EnumAccessModifier':
        items = EnumAccessModifierMD.getItems();
        break;
      case 'EnumInheritanceModifier':
        items = EnumInheritanceModifierMD.getItems();
        break;
      case 'EnumPersistenceType':
        items = EnumPersistenceTypeMD.getItems();
        break;
      case 'EnumMultiplicity':
        items = EnumMultiplicityMD.getItems();
        break;
      case 'EnumRelationshipType':
        items = EnumRelationshipTypeMD.getItems();
        break;
      case 'EnumServiceActionType':
        items = EnumServiceActionTypeMD.getItems();
        break;
      case 'EnumHTTPMethod':
        items = EnumHTTPMethodMD.getItems();
        break;
      case 'EnumNetworkProtocol':
        items = EnumNetworkProtocolMD.getItems();
        break;
      case 'EnumHTTPParameterSource':
        items = EnumHTTPParameterSourceMD.getItems();
        break;
      case 'EnumDTPType':
        items = EnumDTPTypeMD.getItems();
        break;
      case 'EnumPageType':
        items = EnumPageTypeMD.getItems();
        break;
      case 'EnumSearchStyle':
        items = EnumSearchStyleMD.getItems();
        break;
      case 'EnumAlignStyle':
        items = EnumAlignStyleMD.getItems();
        break;
      case 'EnumSortStyle':
        items = EnumSortStyleMD.getItems();
        break;
      case 'EnumRefStyle':
        items = EnumRefStyleMD.getItems();
        break;
      case 'EnumEntityStructureType':
        items = EnumEntityStructureTypeMD.getItems();
        break;
      case 'EnumTreeEntityLevel':
        items = EnumTreeEntityLevelMD.getItems();
        break;
      case 'EnumAPPRelationshipType':
        items = EnumAPPRelationshipTypeMD.getItems();
        break;
      case 'EnumRoleType':
        items = EnumRoleTypeMD.getItems();
        break;
      default:
        break;
    }

    return items;
  }
}
